import { render } from "./Feedback.vue?vue&type=template&id=60cc13ba"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
script.render = render

export default script